export default {
  name: "tree-item",
  props: {
    item: {
      type: Object,
      required: false,
      default: () => ({})
    },
    level: {
      type: Number,
      required: true
    },
    showHeadElements: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data() {
    return {
      isOpen: false,
      isHover: false,
      margin: '',
      extraMargin: '',
      isSelected: false,
      itemClassName: 'item-style-none',
    };
  },
  computed: {

    isLast() {
      return !(this.item.children && this.item.children.length);
    },

    isloading() {
      let result = false;
      if (!this.isLast && this.isOpen) {
        result = this.item.loading;
      }
      return result;
    }
  },

  watch: {
    'item.itemStyle': {
      immediate: true,
      handler(value) {
        if (value) {
          if (value === 'dark') {
            this.itemClassName = 'item-style-dark';
          }
        }
      }
    },
  },

  methods: {

    computeMargin() {
      if (Object.prototype.hasOwnProperty.call(this.item, "leftMargin")) {
        if (this.item.hasExtraColumn) {
          // 追加列あり
          this.margin = `margin-left: ${this.item.leftMargin}`;
          this.extraMargin = `margin-left: ${this.item.extraColumns.margin}`;
        } else {
          // 追加列なし
          this.margin = `margin-left: ${this.item.leftMargin}`;
        }
      }
      else {
        this.margin = `margin-left: ${this.level * 25}px;`;
      }
    },

    expanded(event) {
      if (!this.isLast) {
        this.isOpen = !this.isOpen;
        const expandedData = { data: this.item, isOpen: this.isOpen };

        this.$emit("expanded-item", expandedData);
        event.stopPropagation();
      }
    },

    nodeSelected(event) {
      if (this.item.noSelected) {
        // 選択が無効で設定されている項目は選択イベントを通知しない 
        return;
      }
      const selectData = {
        data: this.item,
        level: this.level
      };
      this.$emit("node-Selected", selectData);
      event.stopPropagation();
    },

    mouseEnterAndlLeave(event, isEnter) {
      let hover = isEnter;
      if (this.item.noSelected) {
        // 選択が無効で設定されている項目は選択イベントを通知しない 
        hover = false;
      }
      this.isHover = hover;
      event.stopPropagation();
    },

    /**
     * 指定したIDに合致するノードを探し、ツリーを開いた状態かつ選択状態にする
     * 子要素が存在する場合、再帰的に実行する
     * @param {boolean} isOpenChildTree 子ノードを表示するツリーを開くかどうか
     */
    setOpenAndSelectTreeNode(selectId, isOpenChildTree) {
      if (this.item.selectId === selectId) {
        // セレクトIDが合致したノードのみ選択状態にする
        this.item.isSelected = true;
        // 子ノードが存在し、子ノードを表示するツリーを開くフラグがtrueの場合、isOpenをtrueにする
        if (!this.isLast && isOpenChildTree) {
          this.isOpen = true;
        }
        // 親ノードを全て開いた状態にするため、通知する
        this.$emit("node-open", selectId);
        return;
      }

      this.item.isSelected = false;

      if (!this.isLast) {
        // 子要素がある場合、配下のtreeViewNodeも再帰的に呼び出す
        this.item.children.forEach((data, index) =>{
          this.$refs.treeViewChildNode[index].setOpenAndSelectTreeNode(selectId, isOpenChildTree);
        });
      }
    },

    /**
     * 引数として渡されたselectIdが子要素に存在する場合、ツリーをオープン状態にする
     * その後、親要素に自身のselectIdを引数としてイベントを伝播させる
     * @param {string} selectId セレクトID
     */
    nodeOpen(selectId) {
      if (!this.isLast) {
        // 子要素からのイベントを想定している為、必ず存在する認識だが、確認を行う
        this.isOpen = this.item.children.some((child) => child.selectId === selectId);

        // 親ノードを全て開いた状態にするため、通知する
        this.$emit("node-open", this.item.selectId);
      }
    }
  },

  mounted() {
    // デフォルトで表示状態にするツリー階層があるかを確認
    if (this.item) {
      if (this.item.isOpen) {
        this.isOpen = true;
        // デフォルトでツリー階層を表示状態にする場合は expand イベントを発行しない
        // this.$emit("expanded-item", { data: this.item, isOpen: true });
      }
    }

    if (!this.showHeadElements) {
      this.isOpen = true;
    }
    this.computeMargin();

    // 初期に選択状態の場合は選択中のイベントを実行する 
    if (this.item.isSelected) {
      const selectData = {
        data: this.item,
        level: this.level
      };
      this.$emit("node-Selected", selectData);
    }
  }

};